import React, { useState, useEffect } from 'react';
import { FaDownload, FaFilePdf, FaArrowLeft, FaExpand, FaCompress, FaChartBar } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const laporanFiles = [
    {
        id: 'juli',
        title: 'Laporan IKM Juli',
        fileName: 'laporan_ikm_bpkad_juli.pdf',
        deskripsi: 'Laporan Indeks Kepuasan Masyarakat periode Juli',
    },
    {
        id: 'umum',
        title: 'Laporan IKM Umum',
        fileName: 'laporan_ikm_bpkad.pdf',
        deskripsi: 'Laporan Indeks Kepuasan Masyarakat keseluruhan',
    },
];

const LaporanIKM = () => {
    const [activeFile, setActiveFile] = useState(laporanFiles[0].fileName);
    const [activeTitle, setActiveTitle] = useState(laporanFiles[0].title);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const pdfUrl = `/${activeFile}`;

    const handleFileChange = (file) => {
        setActiveFile(file.fileName);
        setActiveTitle(file.title);
    };

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = activeFile;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const toggleFullscreen = () => {
        const iframe = document.getElementById('ikm-pdf-iframe');
        if (iframe) {
            if (!document.fullscreenElement) {
                if (iframe.requestFullscreen) iframe.requestFullscreen();
                else if (iframe.webkitRequestFullscreen) iframe.webkitRequestFullscreen();
                setIsFullscreen(true);
            } else {
                if (document.exitFullscreen) document.exitFullscreen();
                else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
                setIsFullscreen(false);
            }
        }
    };

    useEffect(() => {
        const handleFullscreenChange = () => setIsFullscreen(!!document.fullscreenElement);
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
        };
    }, []);

    return (
        <div className="container mx-auto px-4 py-12">
            {/* Header */}
            <div className="mb-8">
                <div className="flex items-center space-x-3 mb-2">
                    <FaChartBar className="text-4xl text-[#2E7D32]" />
                    <div>
                        <h1 className="text-3xl md:text-4xl font-bold text-[#0F4C3A]">
                            Laporan IKM
                        </h1>
                        <p className="text-gray-600 mt-1">
                            Indeks Kepuasan Masyarakat BPKAD Kota Magelang
                        </p>
                    </div>
                </div>
            </div>

            {/* Pilihan Laporan */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                {laporanFiles.map((file) => (
                    <button
                        key={file.id}
                        onClick={() => handleFileChange(file)}
                        className={`card-glass text-left transition-all duration-300 hover:shadow-xl ${activeFile === file.fileName
                                ? 'border-2 border-[#2E7D32] ring-2 ring-[#2E7D32]/20'
                                : 'border border-gray-200'
                            }`}
                    >
                        <div className="flex items-start p-4">
                            <div className="w-12 h-12 bg-gradient-to-br from-[#0F4C3A] to-[#2E7D32] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                                <FaFilePdf className="text-white text-xl" />
                            </div>
                            <div className="flex-1">
                                <h3 className="font-bold text-[#0F4C3A] text-lg">{file.title}</h3>
                                <p className="text-sm text-gray-600">{file.deskripsi}</p>
                                <p className="text-xs text-gray-400 mt-1">Klik untuk menampilkan</p>
                            </div>
                            {activeFile === file.fileName && (
                                <span className="bg-[#2E7D32] text-white text-xs px-3 py-1 rounded-full font-medium">
                                    Aktif
                                </span>
                            )}
                        </div>
                    </button>
                ))}
            </div>

            {/* PDF Viewer */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200">
                <div className="bg-gray-50 px-4 py-3 border-b flex flex-wrap items-center justify-between gap-3">
                    <div className="flex items-center text-sm text-gray-600">
                        <FaFilePdf className="text-red-500 mr-2" />
                        <span className="font-medium">{activeTitle}</span>
                    </div>
                    <div className="flex gap-2">
                        <button
                            onClick={handleDownload}
                            className="flex items-center gap-1 bg-[#2E7D32] hover:bg-[#4CAF50] text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors"
                        >
                            <FaDownload className="mr-1" />
                            Download
                        </button>
                        <button
                            onClick={toggleFullscreen}
                            className="flex items-center gap-1 bg-[#0F4C3A] hover:bg-[#1B5E20] text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors"
                        >
                            {isFullscreen ? <FaCompress className="mr-1" /> : <FaExpand className="mr-1" />}
                            {isFullscreen ? 'Keluar' : 'Fullscreen'}
                        </button>
                        <Link
                            to="/profil/standar-pelayanan"
                            className="flex items-center gap-1 border border-gray-300 text-gray-700 px-4 py-2 rounded-lg text-sm hover:bg-gray-50 transition-colors"
                        >
                            <FaArrowLeft className="mr-1" />
                            Kembali
                        </Link>
                    </div>
                </div>
                <div className="relative" style={{ height: '80vh', minHeight: '500px' }}>
                    <iframe
                        id="ikm-pdf-iframe"
                        src={pdfUrl}
                        title={activeTitle}
                        className="w-full h-full"
                        style={{ border: 'none' }}
                        loading="lazy"
                    >
                        <p>Browser Anda tidak mendukung tampilan PDF.
                            <a href={pdfUrl} download>Silakan download file PDF di sini.</a>
                        </p>
                    </iframe>
                </div>
            </div>

            {/* Petunjuk */}
            <div className="mt-4 bg-yellow-50 p-4 rounded-lg flex items-start">
                <span className="text-yellow-600 mr-3 text-xl">⚠️</span>
                <div>
                    <p className="text-sm text-yellow-800 font-medium">Jika PDF tidak tampil:</p>
                    <ul className="text-sm text-yellow-700 list-disc list-inside mt-1">
                        <li>Pastikan file PDF sudah diletakkan di folder <code className="bg-yellow-100 px-1 rounded">public</code></li>
                        <li>Gunakan browser terbaru untuk dukungan PDF terbaik</li>
                        <li>Klik tombol Download untuk membuka file secara terpisah</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default LaporanIKM;